 $(document).ready(function() {
    $('#searchInput').on('input', function() {
        var query = $(this).val();
        query = query.replace(/\s+/g, '+');
        // Make sure query length is at least 3 characters
        if (query.length >= 3) {

          // Construct the URL with the query parameter
 if (productType === "Custom Driver"){
  var url = `${window.Shopify.routes.root}search?q=driver^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 } else if (productType === "Custom Wood") {
   var url = `${window.Shopify.routes.root}search?q=fairway^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 } else if (productType === "Custom Hybrid") {
  var url = `${window.Shopify.routes.root}search?q=hybrid^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 } else if (productType === "Custom Iron Set") {
  var url = `${window.Shopify.routes.root}search?q=iron^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 } else if (productType === "Custom Wedge") {
  var url = `${window.Shopify.routes.root}search?q=wedge^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 } else if (productType === "Custom Utility Iron") {
  var url = `${window.Shopify.routes.root}search?q=utility^` + query + `&options[unavailable_products]=show&options[prefix]=none&view=shafts`; 
 }
          
    


// Fetch data using fetch API
fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Handle successful response
    displaySuggestions(data.variants, query);
  })
  .catch(error => {
    // Handle error
    console.error('Error:', error);
  });
        } else {
            $('#suggestions').empty(); // Clear suggestions if query is too short
        }
    });
});

function displaySuggestions(suggestions, query) {
    var html = '';
  /*
    var sanitizedQuery = query.replace(/\s+/g, ' ').trim(); // Remove extra whitespace
   

    // Split the sanitized query into individual words
    var words = sanitizedQuery.split(' ');

    // Construct the regular expression pattern to match all words in any order
    var pattern = words.map(function(word) {
        return '(?=.*' + word.split('').join('\\s*') + ')';
    }).join('');

    var regex = new RegExp(pattern, 'i'); // Case-insensitive regex for matching
*/
  suggestions.forEach(function(suggestion){
    html += '<div class="shaft-search-result ' + suggestion.order + '" data-shaftHandle="' + suggestion.handle + '" data-shaftID="' + suggestion.id + '" data-shaftBrand="' + suggestion.vendor + '" data-material="' + suggestion.material + '" data-price="' + suggestion.price + '" data-shaftFlex="' + suggestion.flex + '">';
    html += '<p class="mb-0 option-title-price option-flex"><span class="option-title">' + suggestion.title + '</span><span class="option-price">' + suggestion.price_formatted + '</span></p>';
    if (suggestion.image != ""){
     html += '<img class="shaft-result-image" src="' + suggestion.image + '" alt="' + suggestion.title + '">'; 
    }
    html += '</div>';
});


    $('#suggestions').html(html);
const shaftResults = document.querySelectorAll('.shaft-search-result');

    // Add click event listener to each element
    shaftResults.forEach(result => {
        result.addEventListener('click', function() {
          $(".select-box").addClass("custom-loading");
            // Retrieve the data attributes
            const shaftID = parseInt(this.getAttribute('data-shaftID'));
            const shaftBrand = this.getAttribute('data-shaftBrand');
            const shaftFlex = this.getAttribute('data-shaftFlex');
            const shaftHandle = this.getAttribute('data-shaftHandle');
            const shaftPrice = this.getAttribute('data-price');
            const titlePriceText = this.querySelector('.option-title-price').innerHTML;
            const shaftImage = $(this).find('.shaft-result-image').attr('src');
        if (productType === "Custom Iron Set" || productType === "Custom Wedge" || productType === "Custom Utility Iron"){
   
          const shaftMaterial = this.getAttribute('data-material');
          
          $('input[name="radioMaterial"][value="'+shaftMaterial+'"]').prop('checked', true);

            shaftMaterialSelect(shaftMaterial, shaftBrand);
         
            //$('input[name="radioMaterial"][value="'+shaftMaterial+'"]').click();
      setTimeout(function() {
            $('input[name="flex"][value="'+shaftFlex+'"]').prop('checked', true);
            $("input.drawer-flex[value='" + shaftFlex + "']").prop("checked", true);
          $('.shaftBrandInConfig option[data-handle="'+shaftHandle+'"]').prop('selected', true);
          $('.shaftBrandInConfig').change();

         setTimeout(function() {
        currentShaftValue = shaftID;
          $(".shaft-options").attr("data-price", shaftPrice);
    $(".shaftChoices .selected").html(titlePriceText);
  
    $(".selectedShaftImage").attr("src", shaftImage);
    }, 900);
  
      }, 1600);
          
        } else {
          
           $('input[name="flex"][value="'+shaftFlex+'"]').prop('checked', true);
           $("input.drawer-flex[value='" + shaftFlex + "']").prop("checked", true);

         // $(".shaftBrand").val(shaftBrand).change();
          $('.shaftBrand option[data-handle="'+shaftHandle+'"]').prop('selected', true);
          $('.shaftBrand').change();
           setTimeout(function() {   
    currentShaftValue = shaftID;
    $(".shaft-options").attr("data-price", shaftPrice);
    $(".shaftChoices .selected").html(titlePriceText);
  
    $(".selectedShaftImage").attr("src", shaftImage);
    }, 1600);
        }

           


          $(".shaftSearchContainer").removeClass("active");
     $("body").removeClass("open-cc");
        });
    });
}

 $('.shaftSearch').click(function(e) {
   $(".shaftSearchContainer").addClass("active");
     $("body").addClass("open-cc");
 });



